import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kharghartaxiservice() {



    const cardData = {





keyword: "Kharghar Taxi Services",

headingDescription: "Shreesha Tours & Travels provides reliable Kharghar Taxi Services for local travel, airport transfers, corporate transportation, outstation trips, railway station pickups, family tours, and business journeys. We offer comfortable chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for every travel requirement. With professional drivers, clean and well-maintained cars, flexible booking options, transparent pricing, doorstep pickup, and 24/7 customer support, we ensure a safe and convenient travel experience from Kharghar. Whether you need a local cab, Navi Mumbai Airport transfer, Mumbai travel, or long-distance outstation taxi, Shreesha Tours & Travels provides dependable cab services with complete comfort.",

topPlaces: [
  {
    title: "Kharghar to Navi Mumbai International Airport",
    description: "Navi Mumbai International Airport is an important upcoming aviation hub connecting Navi Mumbai with domestic and international destinations. Travelers from Kharghar require comfortable airport pickup and drop services for business trips, family travel, and flights. A dedicated taxi service ensures timely transfers with professional drivers and clean vehicles."
  },
  {
    title: "Kharghar to Mumbai Airport",
    description: "Mumbai Airport is a major travel hub for domestic and international passengers. Travelers from Kharghar can book reliable airport cabs for early morning flights, business travel, family trips, and guest transportation. Comfortable vehicles with experienced drivers provide a stress-free journey through Mumbai traffic."
  },
  {
    title: "Kharghar to Pune Cab Service",
    description: "Pune is a popular destination from Kharghar for corporate meetings, IT visits, education purposes, and family travel. The city offers attractions like Hinjawadi IT Park, Kharadi business areas, Shaniwar Wada, Sinhagad Fort, and Dagdusheth Ganpati Temple. Kharghar taxi services provide convenient one-way and round-trip travel options."
  },
  {
    title: "Kharghar to Lonavala Taxi",
    description: "Lonavala is a beautiful hill station near Mumbai and Pune known for waterfalls, forts, viewpoints, lakes, and scenic valleys. It is a preferred weekend destination for families, couples, and corporate groups. A private taxi from Kharghar offers comfortable travel with flexible sightseeing options."
  },
  {
    title: "Kharghar to Alibaug Cab",
    description: "Alibaug is a coastal getaway famous for beaches, Kolaba Fort, resorts, and relaxing seaside experiences. Travelers from Kharghar often choose taxi services for weekend trips and family vacations. A comfortable cab allows passengers to enjoy a smooth journey with convenient pickup and drop facilities."
  },
  {
    title: "Kharghar to Shirdi Taxi",
    description: "Shirdi is a famous pilgrimage destination visited by Sai Baba devotees throughout the year. Travelers can visit Sai Baba Temple, Dwarkamai, Chavadi, and nearby spiritual attractions. Kharghar taxi services provide comfortable travel options for families, senior citizens, and groups."
  },
  {
    title: "Kharghar to Mahabaleshwar Cab",
    description: "Mahabaleshwar is a scenic hill station known for viewpoints, strawberry farms, Venna Lake, Mapro Garden, and Pratapgad Fort. It is ideal for family holidays and nature trips. A private taxi service from Kharghar ensures a comfortable hill journey with experienced drivers."
  },
  {
    title: "Kharghar to Nashik Taxi",
    description: "Nashik is a popular religious and tourism destination known for Trimbakeshwar Jyotirlinga, Panchavati, vineyards, and historical attractions. Travelers from Kharghar can book taxis for pilgrimage tours, business visits, and sightseeing trips with flexible travel plans."
  },
  {
    title: "Kharghar to Goa Cab",
    description: "Goa is one of India's most popular holiday destinations famous for beaches, forts, churches, nightlife, and scenic coastal locations. Kharghar taxi services provide comfortable long-distance vehicles like Innova, Ertiga, and Tempo Traveller for families and groups planning a Goa road trip."
  },
  {
    title: "Kharghar Local City Taxi",
    description: "Local taxi services in Kharghar are suitable for daily commuting, shopping trips, railway station transfers, hospital visits, business meetings, and city travel. With reliable vehicles and professional drivers, passengers can enjoy convenient transportation across Kharghar, Navi Mumbai, and nearby areas."
  }
],


"services": [
  {
    "name": "Cab Service in Kharghar",
    "description": "Book Cab Service in Kharghar for safe, reliable, and comfortable travel with professional chauffeurs and well-maintained AC vehicles. Get convenient cab solutions for local rides, airport transfers, corporate travel, family trips, sightseeing, railway station pickup, one-way drops, and outstation journeys. Choose from Sedan, Hyundai Aura, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and luxury cab options with affordable pricing and easy booking facilities."
  },
  {
    "name": "Kharghar Taxi Services",
    "description": "Choose Kharghar Taxi Services for dependable transportation with experienced drivers, clean vehicles, and flexible travel options. Our taxi services are suitable for daily travel, airport transfers, business trips, family requirements, and long-distance routes. Enjoy comfortable rides with multiple vehicle choices, transparent pricing, doorstep pickup, and professional service available for local and outstation destinations."
  },
  {
    "name": "Kharghar Cab Service",
    "description": "Get Kharghar Cab Service for affordable and convenient transportation with skilled chauffeurs and premium AC cars. Whether you need a local cab, airport taxi, corporate travel vehicle, or outstation cab, enjoy smooth journeys with reliable service. Select from Sedan, Ertiga, Innova, Innova Crysta, SUV, and luxury vehicles according to your travel requirements."
  },
  {
    "name": "Kharghar Taxi Booking",
    "description": "Complete Kharghar Taxi Booking online with quick confirmation, flexible pickup locations, and multiple vehicle options. Travel comfortably with professional drivers, clean interiors, and reliable taxi services for personal, business, airport, and outstation travel. Enjoy hassle-free booking with affordable fares and timely transportation support."
  },
  {
    "name": "Kharghar Outstation Taxi",
    "description": "Book Kharghar Outstation Taxi for comfortable long-distance travel with experienced chauffeurs and well-maintained vehicles. Perfect for family vacations, business trips, weekend tours, and intercity journeys. Get reliable one-way and round-trip taxi services with spacious cars, transparent charges, and convenient pickup from Kharghar."
  },
  {
    "name": "Kharghar AC Cab Service",
    "description": "Choose Kharghar AC Cab Service for comfortable travel in clean and air-conditioned vehicles with professional drivers. Ideal for local travel, airport transfers, corporate transportation, and outstation trips. Enjoy a smooth journey with affordable fares, flexible booking options, and premium comfort throughout your ride."
  },
  {
    "name": "Kharghar Airport Taxi",
    "description": "Reserve Kharghar Airport Taxi for punctual airport pickup and drop services with trained chauffeurs and comfortable AC vehicles. Get reliable airport transportation with luggage assistance, timely arrivals, and convenient booking options for Mumbai Airport and Navi Mumbai International Airport transfers."
  },
  {
    "name": "Kharghar Tourist Taxi Service",
    "description": "Explore destinations with Kharghar Tourist Taxi Service offering comfortable sightseeing travel with experienced drivers and private vehicles. Plan family tours, weekend trips, and holiday journeys with flexible routes, premium cars, and reliable transportation support for nearby and long-distance tourist locations."
  },
  {
    "name": "Kharghar One Way Cab",
    "description": "Book Kharghar One Way Cab for affordable point-to-point travel without return charges. Enjoy convenient drop taxi services with professional chauffeurs, comfortable AC vehicles, and flexible pickup timings. Suitable for airport drops, city transfers, and intercity travel from Kharghar."
  },
  {
    "name": "Kharghar Outstation Cab",
    "description": "Choose Kharghar Outstation Cab for safe and comfortable long-distance journeys with reliable drivers and spacious vehicles. Travel to Pune, Goa, Nashik, Mumbai, and other destinations with one-way and round-trip options. Enjoy affordable pricing, doorstep pickup, and professional chauffeur-driven service."
  },
  {
    "name": "Kharghar Outstation Taxi",
    "description": "Book Kharghar Outstation Taxi for convenient intercity travel with premium vehicles and experienced chauffeurs. Our taxi services provide comfortable rides for families, corporate travelers, and tourists with flexible schedules, affordable fares, and reliable transportation solutions."
  },
  {
    "name": "Kharghar Outstation Cab Service",
    "description": "Get Kharghar Outstation Cab Service for dependable long-distance transportation with clean AC cars and professional drivers. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, and premium cabs for business trips, vacations, and personal travel."
  },
  {
    "name": "Kharghar One Way Outstation Cab",
    "description": "Reserve Kharghar One Way Outstation Cab for economical drop taxi services to different cities without paying return charges. Enjoy comfortable travel, experienced chauffeurs, flexible booking, and well-maintained vehicles for hassle-free intercity journeys."
  },
  {
    "name": "Kharghar Tourist Cab",
    "description": "Hire Kharghar Tourist Cab for private sightseeing and holiday trips with experienced drivers and comfortable vehicles. Travel conveniently with customized tour plans, flexible routes, and reliable cab services for families, groups, and tourists."
  },
  {
    "name": "Kharghar Intercity Taxi Service",
    "description": "Choose Kharghar Intercity Taxi Service for smooth city-to-city travel with professional chauffeurs and comfortable AC vehicles. Enjoy reliable transportation for business travel, family visits, airport transfers, and long-distance journeys."
  },
  {
    "name": "Kharghar Private Taxi Service",
    "description": "Book Kharghar Private Taxi Service for personalized travel with dedicated vehicles and professional drivers. Enjoy privacy, comfort, and flexible travel schedules for local rides, airport transfers, sightseeing, and outstation trips."
  },
  {
    "name": "Kharghar to Pune Cab",
    "description": "Book Kharghar to Pune Cab for comfortable and affordable travel between Kharghar and Pune. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, and premium vehicles with experienced chauffeurs for business trips, family travel, and airport transfers."
  },
  {
    "name": "Kharghar to Pune Cab Service",
    "description": "Get Kharghar to Pune Cab Service with reliable drivers, clean AC vehicles, and flexible booking options. Enjoy safe highway travel with one-way and round-trip cab facilities designed for comfortable intercity transportation."
  },
  {
    "name": "Kharghar to Pune Taxi",
    "description": "Reserve Kharghar to Pune Taxi for convenient travel with professional chauffeurs and affordable pricing. Travel comfortably with private taxi options suitable for individuals, families, and corporate passengers."
  },
  {
    "name": "Kharghar to Pune Taxi Service",
    "description": "Choose Kharghar to Pune Taxi Service for reliable transportation with experienced drivers and premium vehicles. Enjoy smooth rides with doorstep pickup, flexible schedules, and comfortable travel arrangements."
  },
  {
    "name": "Kharghar to Pune One Way Cab",
    "description": "Book Kharghar to Pune One Way Cab for economical drop taxi service without return charges. Enjoy direct travel with professional chauffeurs, comfortable cars, and affordable intercity transportation."
  },
  {
    "name": "Kharghar to Pune Outstation Cab",
    "description": "Hire Kharghar to Pune Outstation Cab for safe and comfortable long-distance travel. Get reliable vehicles, skilled drivers, and flexible one-way or round-trip options for personal and business journeys."
  },
  {
    "name": "Kharghar to Goa Cabs",
    "description": "Book Kharghar to Goa Cabs for enjoyable holiday travel with comfortable vehicles and professional chauffeurs. Choose premium and budget-friendly cars for family vacations, beach trips, sightseeing, and weekend getaways."
  },
  {
    "name": "Kharghar to Goa Cab Service",
    "description": "Choose Kharghar to Goa Cab Service for reliable long-distance travel with clean AC vehicles and experienced drivers. Enjoy smooth highway journeys with flexible booking options and comfortable travel solutions."
  },
  {
    "name": "Kharghar to Goa Taxi",
    "description": "Reserve Kharghar to Goa Taxi for safe and convenient transportation to Goa. Travel comfortably with private taxis, professional chauffeurs, and spacious vehicles suitable for families and groups."
  },
  {
    "name": "Kharghar to Goa Taxi Service",
    "description": "Get Kharghar to Goa Taxi Service for affordable holiday transportation with reliable drivers and premium vehicles. Enjoy one-way, round-trip, and customized Goa travel packages."
  },
  {
    "name": "Kharghar to Goa One Way Cab",
    "description": "Book Kharghar to Goa One Way Cab for hassle-free drop taxi service with no return charges. Enjoy comfortable travel with experienced chauffeurs and flexible pickup options."
  },
  {
    "name": "Kharghar to Goa Outstation Cab",
    "description": "Choose Kharghar to Goa Outstation Cab for private road trips with comfortable seating and professional drivers. Ideal for vacations, family tours, and long-distance travel requirements."
  },
  {
    "name": "Best Kharghar to Goa Cab",
    "description": "Book the Best Kharghar to Goa Cab for premium travel experience with reliable service, clean vehicles, and experienced chauffeurs. Enjoy safe and comfortable journeys with multiple vehicle options."
  },
  {
    "name": "Cheap Kharghar to Goa Taxi",
    "description": "Get Cheap Kharghar to Goa Taxi service with affordable fares, quality vehicles, and dependable drivers. Enjoy budget-friendly travel without compromising comfort and safety."
  },
  {
    "name": "Online Kharghar to Goa Cab Booking",
    "description": "Complete Online Kharghar to Goa Cab Booking with instant confirmation, easy reservations, and multiple car choices. Enjoy convenient digital booking for comfortable Goa travel."
  },
  {
    "name": "Kharghar to Nashik Cab",
    "description": "Book Kharghar to Nashik Cab for comfortable travel with professional drivers and well-maintained vehicles. Suitable for business trips, family visits, religious tours, and sightseeing journeys."
  },
  {
    "name": "Kharghar to Nashik Taxi",
    "description": "Choose Kharghar to Nashik Taxi for reliable intercity transportation with affordable fares and comfortable AC vehicles. Enjoy smooth travel with experienced chauffeurs and flexible booking options."
  },
  {
    "name": "Kharghar to Nashik Cab Service",
    "description": "Get Kharghar to Nashik Cab Service for safe and convenient travel with premium vehicles and professional drivers. Enjoy reliable transportation for personal, corporate, and tourist requirements."
  },
  {
    "name": "Kharghar to Nashik One Way Cab",
    "description": "Reserve Kharghar to Nashik One Way Cab for affordable direct travel without return charges. Enjoy comfortable rides, timely pickup, and professional chauffeur service."
  },
  {
    "name": "Kharghar to Nashik Outstation Taxi",
    "description": "Book Kharghar to Nashik Outstation Taxi for comfortable long-distance travel with reliable vehicles and experienced chauffeurs. Perfect for family trips, business journeys, and Nashik sightseeing."
  }
],
"tableData": [
  ["Cab Service in Kharghar", "Kharghar Taxi Services"],
  ["Kharghar Cab Service", "Kharghar Taxi Booking"],
  ["Kharghar Outstation Taxi", "Kharghar AC Cab Service"],
  ["Kharghar Airport Taxi", "Kharghar Tourist Taxi Service"],
  ["Kharghar One Way Cab", "Kharghar Outstation Cab"],
  ["Kharghar Outstation Taxi", "Kharghar Outstation Cab Service"],
  ["Kharghar One Way Outstation Cab", "Kharghar Tourist Cab"],
  ["Kharghar Intercity Taxi Service", "Kharghar Private Taxi Service"],
  ["Kharghar to Pune Cab", "Kharghar to Pune Cab Service"],
  ["Kharghar to Pune Taxi", "Kharghar to Pune Taxi Service"],
  ["Kharghar to Pune One Way Cab", "Kharghar to Pune Outstation Cab"],
  ["Kharghar to Goa Cabs", "Kharghar to Goa Cab Service"],
  ["Kharghar to Goa Taxi", "Kharghar to Goa Taxi Service"],
  ["Kharghar to Goa One Way Cab", "Kharghar to Goa Outstation Cab"],
  ["Best Kharghar to Goa Cab", "Cheap Kharghar to Goa Taxi"],
  ["Online Kharghar to Goa Cab Booking", "Kharghar to Nashik Cab"],
  ["Kharghar to Nashik Taxi", "Kharghar to Nashik Cab Service"],
  ["Kharghar to Nashik One Way Cab", "Kharghar to Nashik Outstation Taxi"]
],



whychoose: [
  {
    WhyChooseheading: "Reliable Kharghar Taxi Services for Local & Outstation Travel",
    WhyChoosedescription: "Shreesha Travels offers dependable Kharghar taxi services for daily travel, airport transfers, corporate trips, family outings, and long-distance journeys. Enjoy comfortable rides with professional chauffeurs and well-maintained vehicles."
  },
  {
    WhyChooseheading: "Convenient Pickup Across Kharghar",
    WhyChoosedescription: "Get easy cab availability from residential areas, offices, hotels, railway stations, and important locations across Kharghar with smooth pickup and drop facilities."
  },
  {
    WhyChooseheading: "Cars Available for Every Travel Requirement",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles based on your passenger count and comfort needs."
  },
  {
    WhyChooseheading: "Airport, Corporate & Outstation Cab Solutions",
    WhyChoosedescription: "The service is suitable for Navi Mumbai Airport transfers, Mumbai Airport travel, business meetings, employee transportation, weekend trips, and outstation destinations across Maharashtra."
  },
  {
    WhyChooseheading: "One Way & Round Trip Booking Options",
    WhyChoosedescription: "Plan your journey with flexible one-way taxi booking or round-trip cab packages for destinations like Mumbai, Pune, Goa, Nashik, Shirdi, Mahabaleshwar, and other cities."
  },
  {
    WhyChooseheading: "Experienced Drivers with Local Route Knowledge",
    WhyChoosedescription: "Professional chauffeurs understand Kharghar and Navi Mumbai routes, helping passengers reach destinations safely with timely service and comfortable driving."
  },
  {
    WhyChooseheading: "Clean & Comfortable Fleet",
    WhyChoosedescription: "Every vehicle is regularly serviced, sanitized, air-conditioned, and checked before trips to provide a safe and pleasant travel experience."
  },
  {
    WhyChooseheading: "Book Kharghar Taxi Services with Shreesha Travels",
    WhyChoosedescription: "Get transparent pricing, quick booking assistance, reliable transportation, and professional chauffeur-driven cars for your local and outstation travel needs from Kharghar."
  }
]

};

const faqData = [
  {
    question: "What types of Kharghar taxi services are available?",
    answer: "Kharghar taxi services include local city transfers, airport cabs, corporate travel, one-way trips, round trips, and outstation journeys."
  },
  {
    question: "Can I book a taxi from Kharghar to Mumbai Airport?",
    answer: "Yes, airport pickup and drop services are available from Kharghar to Mumbai Airport and Navi Mumbai International Airport."
  },
  {
    question: "Which vehicles are available for Kharghar cab booking?",
    answer: "Available vehicles include Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium cars."
  },
  {
    question: "Do you provide outstation taxi service from Kharghar?",
    answer: "Yes, outstation cabs are available from Kharghar to Pune, Goa, Nashik, Shirdi, Mahabaleshwar, Kolhapur, Gujarat, and other destinations."
  },
  {
    question: "Can I hire a cab for corporate travel in Kharghar?",
    answer: "Yes, corporate cab solutions are available for office travel, employee transportation, client pickups, and business meetings."
  },
  {
    question: "Is Kharghar taxi service available 24 hours?",
    answer: "Yes, cab bookings can be arranged according to passenger travel schedules and requirements."
  },
  {
    question: "Can I book a one-way taxi from Kharghar?",
    answer: "Yes, one-way cab services are available for direct travel to your preferred destination."
  },
  {
    question: "How is Kharghar taxi fare calculated?",
    answer: "The fare depends on vehicle type, distance, route, travel duration, toll charges, parking fees, and additional requirements."
  },
  {
    question: "Can I book a cab for family trips from Kharghar?",
    answer: "Yes, comfortable vehicles are available for families, senior citizens, couples, and groups travelling locally or outstation."
  },
  {
    question: "How can I book Kharghar Taxi Services with Shreesha Travels?",
    answer: "Share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive a customized quotation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Joshi",
    feedback: "The Kharghar taxi service provided a comfortable ride with a clean vehicle and professional driver. The pickup was smooth and the journey was well managed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback: "A reliable cab option for airport and outstation travel from Kharghar. The chauffeur was polite, punctual, and made the trip convenient.",
    rating: 5
  }
];




    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kharghar Taxi Services",
  "image": "https://www.shreeshatravels.com/assets/images/kharghar-taxi-services.webp",
  "description":
    "Book Kharghar Taxi Services with Shreesha Tours & Travels for safe, comfortable, and reliable taxi solutions. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for local travel, airport transfers, outstation trips, family journeys, business travel, and long-distance routes from Kharghar with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/kharghar-taxi-services"
  }
};


    return (
        <div>

<Helmet>
  <title>Kharghar Taxi Services | Cab Booking Kharghar | +91 8355835813</title>

  <meta
    name="description"
    content="Book Kharghar Taxi Services with Shreesha Travels for safe and comfortable taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for local travel, airport transfers, outstation trips, family tours, business travel, and 24x7 cab booking in Kharghar."
  />

  <meta
    name="keywords"
    content="Cab Service in Kharghar, Kharghar Taxi Services, Kharghar Cab Service, Kharghar Taxi Booking, Kharghar Outstation Taxi, Kharghar AC Cab Service, Kharghar Airport Taxi, Kharghar Local Taxi, Kharghar Car Rental, Best Taxi Service Kharghar, Kharghar Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/118.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Kharghartaxiservice;